import { Navbar } from '@/components/Navbar';
import { Hero } from '@/components/Hero';
import { Reviews } from '@/components/Reviews';
import { Clients } from '@/components/Clients';
import { Stats } from '@/components/Stats';
import { VideoShowcase } from '@/components/VideoShowcase';
import { CaseStudiesTeaser } from '@/components/CaseStudiesTeaser';
import { Team } from '@/components/Team';
import { HomeSeo } from '@/components/HomeSeo';
import { HomeFaq } from '@/components/HomeFaq';
import { ForYouIf } from '@/components/ForYouIf';
import { Method } from '@/components/Method';
import { Comparison } from '@/components/Comparison';
import { Helmet } from 'react-helmet-async';
import { Footer } from '@/components/Footer';

const TaohMathis = () => {
  return (
    <main className="min-h-screen bg-background overflow-x-hidden">
      <Helmet>
        <title>10 Kitchen Remodeling Jobs in 90 Days | The Alpha Omega Hub</title>
        <meta name="description" content="We help $3M+ kitchen remodelers land 10 new jobs in 90 days with our Scroll-to-Kitchen System, or we keep booking appointments free until you do." />
        <meta property="og:title" content="10 Kitchen Remodeling Jobs in 90 Days | The Alpha Omega Hub" />
        <meta property="og:description" content="We help $3M+ kitchen remodelers land 10 new jobs in 90 days with our Scroll-to-Kitchen System, or we keep booking appointments free until you do." />
        <meta name="twitter:title" content="10 Kitchen Remodeling Jobs in 90 Days | The Alpha Omega Hub" />
        <meta name="twitter:description" content="We help $3M+ kitchen remodelers land 10 new jobs in 90 days with our Scroll-to-Kitchen System, or we keep booking appointments free until you do." />
        <link rel="canonical" href="https://thealphaomegahub.com/" />
      </Helmet>
      <Navbar />
      <Hero />
      <Clients />
      <VideoShowcase />
      <Stats />
      <CaseStudiesTeaser />
      <ForYouIf />
      <Method />
      {/* AI chat (GoHighLevel) section hidden for now — re-add <AiChat /> here to bring it back */}
      <Comparison />
      <Reviews />
      <Team />
      <HomeSeo />
      <HomeFaq />
      <Footer />
    </main>
  );
};

export default TaohMathis;
